import { ResourceContext } from '@flos/react-ui';
import { useContext } from 'react';

const useResource = () => useContext(ResourceContext);

export default useResource;
